import React from 'react';
import { properties } from './properties';

function ErrorPage(props){
    return (
        <div className="error-page">
            <h1>{props.code}</h1>
            <h2>Oops{properties.RESPONSE_STATUS_MESSAGE[props.code]}</h2>
            <p>Something went wrong</p>
        </div>
    );
}

export default ErrorPage;